import { Box, Typography } from '@mui/material';
import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { LineItem, Image } from 'components';

const CostItemDetails = ({ costItem }) => (
	<List>
		<LineItem label="Name" value={costItem.name} />
		<LineItem label="Type" value={costItem.item} />
		<LineItem label="Coins" value={costItem.cost} />
	</List>
);

export default CostItemDetails;
